// @flow
import React from 'react';
import { DateUtils } from 'react-day-picker';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { formatMonthTitle } from 'Components/frameworks/datepicker/Datepicker.utils';

type Props = {
  fromMonth: Date,
  locale?: string,
  month?: Date,
  onNext: () => void,
  onPrevious: () => void,
  toMonth: Date,
};

// https://react-day-picker.js.org/api/DayPicker#navbarElement

export function DatePickerCaption({
  fromMonth,
  locale = 'en',
  month,
  onNext,
  onPrevious,
  toMonth,
}: Props) {
  const { isSameMonth } = DateUtils;
  return (
    <div className="flex items-center justify-between">
      {!isSameMonth(month, fromMonth) ? (
        <button
          className="h-9 reset-button"
          data-testid="datepicker-arrow-prev"
          onClick={onPrevious}
          style={{ width: 30 }}
          type="button"
        >
          <Icon
            color={COLORS.GRAY_DARKER}
            hasRtl
            name={ICONS.BOLDER_ARROW_FORTH}
            rotation={180}
            width="0.625rem"
          />
        </button>
      ) : (
        <div className="h-9" style={{ width: 30 }} />
      )}
      <span className="flex-1 text-base text-center">{formatMonthTitle(month, locale)}</span>
      {!isSameMonth(month, toMonth) ? (
        <button
          className="h-9 reset-button"
          data-testid="datepicker-arrow-next"
          onClick={onNext}
          style={{ width: 30 }}
          type="button"
        >
          <Icon
            color={COLORS.GRAY_DARKER}
            hasRtl
            name={ICONS.BOLDER_ARROW_FORTH}
            width="0.625rem"
          />
        </button>
      ) : (
        <div className="h-9" style={{ width: 30 }} />
      )}
    </div>
  );
}
